import { Indicator } from "../indicator/indicator";
import { EMA } from "./EMA";
//Form
// dema = 2 * ema(in) - ema(ema(in))
export class DEMA extends Indicator {
    constructor(input) {
        super(input);
        const period = input.period;
        const priceArray = input.values;
        let ema1;
        let ema2;
        let format = this.format;
        this.result = [];
        let emaIndex = 0;
        const genFn = (function* () {
            ema1 = new EMA({
                period: period,
                values: [],
                format: (v) => { return Number(v.toFixed(2)); }
            });
            ema2 = new EMA({
                period: period,
                values: [],
                format: (v) => { return Number(v.toFixed(2)); }
            });
            let tick = yield;
            while (true) {
                let lastEma = ema1.nextValue(tick);
                let emaDouble = lastEma ? ema2.nextValue(lastEma) : undefined;
                let result = emaDouble ? 2 * lastEma - emaDouble : undefined;
                tick = yield result ? format(Number(result.toFixed(2))) : undefined;
            }
        });
        this.generator = genFn();
        this.generator.next();
        priceArray.forEach((tick) => {
            const result = this.generator.next(tick);
            if (result.value != undefined) {
                this.result.push(this.format(result.value));
            }
        });
    }
    nextValue(price) {
        const result = this.generator.next(price).value;
        if (result !== undefined) {
            return this.format(result);
        }
    }
    ;
}
DEMA.calculate = dema;
export function dema(input) {
    Indicator.reverseInputs(input);
    const result = new DEMA(input).result;
    if (input.reversedInput) {
        result.reverse();
    }
    Indicator.reverseInputs(input);
    return result;
}
